import { FunctionComponent, lazy } from "react";
import { AppContent as Component } from "./AppContent";

export const AppContent = lazy<FunctionComponent>(() => {
  return new Promise(resolve => {
    resolve({ default: Component });
  });
});
